import React from 'react';
import cn from 'classnames';

import { mq } from 'react-scale/components/website/big/Themes';

const FeaturesList = ({ items, onHover, iconSrc, top, bottom }) => (
  <ul className={cn({ top, bottom })}>
    {items.map(item => {
      if (item.type) {
        return (
          <li
            onClick={() => onHover(item.type)}
            onMouseEnter={() => onHover(item.type)}
            onMouseLeave={() => onHover('')}
            key={item.text}
          >
            <p>
              <span className="text">{item.text}</span>
            </p>
          </li>
        );
      } 
      return (
        <li key={item.text}>
          <p>
            {item.text}
          </p>
        </li>
      );
    })}
    <style jsx>{`
      ul {
        padding: 0;
        list-style: none;
      }
      ul.top {
        margin-top: 2rem;
      }
      ul.bottom {
        margin-bottom: 2rem;
      }

      li {
        background-size: 2rem 2rem;
        background-position: 0 5.5px;
        background-repeat: no-repeat;
        background-image: url('/static/img/website/open-datasets/${iconSrc}/check-icon.svg');
        padding: 0 0 0 2rem;
        white-space: nowrap;
      }
      @media (min-width: ${mq.lg}) {
        li {
          background-position: 0;
          background-size: 24px;
          margin: 0;
          padding: 0 0 0 calc(2rem * 1.2);
          white-space: normal;
        }
      }
      li:not(:last-child) {
        margin: 0 calc(2rem / 2) calc(2rem / 2) 0;
      }
      @media (min-width: ${mq.lg}) {
        li:not(:last-child) {
          margin: 0 0 calc(2rem / 2);
        }
      }

      .text {
        color: #008eff;
        border-bottom: 1px dashed #008EFF;
        cursor: pointer;
      }
    `}</style>
  </ul>
);

FeaturesList.defaultProps = {
  top: false, // adds margin top
  bottom: false // adds margin bottom
};

export default FeaturesList;
